<template>
  <div>
    <v-menu offset-y left content-class="account-menu-dropdown" transition="slide-y-transition" nudge-bottom="8">
      <template v-slot:activator="{ attrs, on }">
        <div
          v-bind="attrs"
          v-on="on"
          class="account-activator-pill"
        >
          <v-icon color="#334155" size="20" class="mr-1">
            mdi-account-circle-outline
          </v-icon>
          <span class="account-activator-text">Account</span>
          <v-icon size="14" color="#64748b" class="ml-1">mdi-chevron-down</v-icon>
        </div>
      </template>
      <v-card class="account-menu-card" width="240px">
        <v-layout wrap justify-center py-3>
          <v-flex xs12 class="text-center py-2">
            <div class="user-avatar-container">
              <span v-if="userInitial" class="user-avatar-initial">{{ userInitial }}</span>
              <v-icon v-else color="#2e6b3f" size="30">mdi-account</v-icon>
            </div>
          </v-flex>
          
          <v-flex xs12 class="text-center px-4" v-if="appLogin">
            <router-link :to="appUserrole === 'admin' || appUserrole === 'SEOC' ? '/Admin/profile' : '/Officers/profile'" class="profile-link">
              <div class="user-name">{{ appUser }}</div>
              <div class="user-role-badge">{{ appUserrole }}</div>
            </router-link>
          </v-flex>

          <v-flex xs12 class="text-center pt-3 pb-1 px-4">
            <v-divider class="my-2"></v-divider>
            <v-btn
              v-if="!appLogin"
              color="#2e6b3f"
              depressed
              block
              rounded
              class="text-capitalize login-btn"
              to="/login"
            >
              Login
            </v-btn>
            <v-btn
              v-if="appLogin"
              color="#c0392b"
              text
              block
              rounded
              class="text-capitalize logout-btn mt-1"
              @click="appLogout"
            >
              <v-icon left size="16">mdi-logout</v-icon>
              Logout
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
// import Socket from "./../../Sockets/socket";
// import axios from 'axios'
export default {
  data() {
    return {
      user: {},
    };
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appUser() {
      return this.$store.state.userName;
    },
    appUserrole() {
      return this.$store.state.userRole;
    },
    userInitial() {
      const name = this.$store.state.userName;
      return name ? String(name).trim().charAt(0) : "";
    },
  },
  methods: {
    appLogout() {
      // Socket.authFunction(this);
      this.$store.commit("logoutUser", true);
    },
    // appLogout() {
			
		// 	axios({
		// 		method: "GET",
		// 		url: "/user/logout",
		// 		headers: {
		// 			"x-auth-token": localStorage.getItem("token")
		// 		}
		// 	}).then(response => {
		// 		if (response.data) {
		// 			localStorage.removeItem("token");
		// 			localStorage.removeItem("userRole");
		// 			if (window.location.pathname != '/') {
    //         this.$router.push('/login')

		// 			}
		// 		}
		// 	})
		// },
  },
  sockets: {
    connect() {
      // Fired when the socket connects.
      this.isConnected = true;
    },

    disconnect() {
      this.isConnected = false;
    },

    // Fired when the server sends something on the "messageChannel" channel.
    messageChannel(data) {
      this.socketMessage = data;
    },
  },
};
</script>

<style scoped>
.account-activator-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  background-color: #f7faf8;
  border: 1px solid #dfe6e1;
  border-radius: 9999px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.02);
}

.account-activator-pill:hover {
  background-color: #eef4f0;
  border-color: #b9cbbf;
  transform: translateY(-0.5px);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}

.account-activator-text {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #334155;
}

/* Dropdown Menu Card */
.account-menu-card {
  border-radius: 16px !important;
  border: 1px solid #f1f5f9 !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.03) !important;
  background: #ffffff !important;
  overflow: hidden;
}

/* User Avatar Container */
.user-avatar-container {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e6f0e8 0%, #cfe3d5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 4px 6px -1px rgba(46, 107, 63, 0.12), 0 2px 4px -1px rgba(46, 107, 63, 0.08);
}

.user-avatar-initial {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 21px;
  font-weight: 600;
  color: #1f5b33;
  line-height: 1;
  text-transform: uppercase;
}

/* Profile Link & Hover States */
.profile-link {
  text-decoration: none !important;
  display: block;
  padding: 8px;
  border-radius: 10px;
  transition: background-color 0.2s ease;
}

.profile-link:hover {
  background-color: #f8fafc;
}

/* Typography styles */
.user-name {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  margin-top: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role-badge {
  display: inline-block;
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #1f5b33;
  background: #e4efe7;
  padding: 2px 8px;
  border-radius: 9999px;
  margin-top: 4px;
}

/* Button styles */
.login-btn {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 13px !important;
  font-weight: 500 !important;
  letter-spacing: 0.5px !important;
  color: #ffffff !important;
  box-shadow: 0 4px 6px -1px rgba(46, 107, 63, 0.2) !important;
  transition: all 0.2s ease !important;
}

.login-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 10px -1px rgba(46, 107, 63, 0.3) !important;
}

.logout-btn {
  font-family: 'Poppins', 'Inter', sans-serif;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #b3261e !important;
  border: 1px solid #f0dcd9 !important;
  background-color: #fbf3f2 !important;
  transition: all 0.2s ease !important;
}

.logout-btn:hover {
  background-color: #f7e4e1 !important;
  color: #8f1d15 !important;
  transform: translateY(-1px);
}
</style>